import { type yup } from '@framework/validation/initYup.ts';
import { isEqual } from 'lodash';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { type AnyObject } from 'yup';

export interface IAdvancedSearchQueryValuesSetterProps {
  query: AnyObject | undefined | null;
  schema: yup.ObjectSchema<AnyObject>;
}

export function AdvancedSearchQueryValuesSetter(
  props: IAdvancedSearchQueryValuesSetterProps,
) {
  const { getValues, reset } = useFormContext();
  useEffect(() => {
    const nextValues = props.schema.cast(props.query, { assert: false });
    if (!isEqual(nextValues, getValues())) {
      reset(nextValues, { keepDefaultValues: false });
    }
  }, [getValues, props.query, props.schema, reset]);

  return null;
}
